var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 5C18 5 13.8725 2.10784 9.74491 1.10294C8.52375 0.808824 9.47626 3.40686 9.01221 3.43137C8.37721 3.45588 8.25509 3.40686 8.25509 3.40686C7.71777 3.13725 7.20488 0.784314 6.56988 0.588235C5.4464 0.269608 3.981 0.0245098 3.54138 0L6.71642 4.43627L0 4.19118V5.80882L6.71642 5.56373L4.02985 10C4.46947 9.97549 5.4464 9.73039 6.5943 9.38725C7.20489 9.21569 7.71778 6.83823 8.27951 6.56863C8.27951 6.56863 8.40163 6.51961 9.03664 6.54412C9.50068 6.56863 8.54817 9.16667 9.76934 8.87255C13.8725 7.89216 18 5 18 5Z"}));
}

Arrow.defaultProps = {"viewBox":"0 0 18 10"};

module.exports = Arrow;

Arrow.default = Arrow;
